import { IPersistentNotification } from "flow/interfaces/IPersistentNotification";
import ko from "knockout";

export const globalPersistentNotifications = ko.observableArray<IPersistentNotification>([]);

export function addGlobalPersistentNotification(persistentNotifiation: IPersistentNotification) {
    globalPersistentNotifications.push(persistentNotifiation);
}
